import { api } from "@/lib/api-client";

/** False until the client's features have loaded, so a client with `preventMarketplaceSync` is never offered a marketplace link. */
export function useShowsMarketplaceLinks(): boolean {
  const { data } = api.client.useGetClientFeatures();
  return (
    data?.features !== undefined &&
    !data.features.includes("preventMarketplaceSync")
  );
}
